import { render, staticRenderFns } from "./BillAdjustmentDetail.vue?vue&type=template&id=2c6c5fe2&scoped=true"
import script from "./BillAdjustmentDetail.vue?vue&type=script&lang=js"
export * from "./BillAdjustmentDetail.vue?vue&type=script&lang=js"
import style0 from "./BillAdjustmentDetail.vue?vue&type=style&index=0&id=2c6c5fe2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c5fe2",
  null
  
)

export default component.exports